﻿$.fn.dxCtrlPageVerifySmtp = function custom_dxCtrlPageVerifySmtp(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlpageverifysmtp dx-ctrl");
        this.createInstance(new cdxCtrlPageVerifySmtp(this, option));
    }
    return this;
}

window.cdxCtrlPageVerifySmtp = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        container.css({
            "display": "flex",
            "align-items": "center",
            "justify-content": "center",
            "text-align": "center"
        })
        var $DivContent = $("<div style='width:100%;max-width:500px;'/>").appendTo(container)
        $("<div/>").appendTo($DivContent).dxCtrlEnteteTitleApp({
            bddCtrl: option.bddCtrl
        })
        $("<div style='font-size:200%;padding:10px;'>Tester la délivrabilité d'un SMTP</div>").appendTo($DivContent)
        var $Table = $("<table/>").appendTo($DivContent)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        if (option.verify_smtp_compte_client) {
            $("<div style='width:100%;'/>").appendTo($Td).dxCtrlTestSmtpLeadQuot({
                bddCtrl: option.bddCtrl
            })
        } else {
            $("<div style='width:100%;'/>").appendTo($Td).dxCtrlCompteEmailTestDelivrabilite({
                bddCtrl: option.bddCtrl
            })
        }
        var $Td = $("<td style='width:à%;border-left:" + theme.border + ";height:1px;vertical-align:top;'/>").appendTo($Tr)
        //mRempliHtmlEditor($Td)
    }

    function mRempliHtmlEditor(contentElement) {
        var $DivToolBar = $("<div id='divhtmltoolbar" + idxInstance + "' class='' style='background-color:transparent'/>").appendTo(contentElement)
        var $DivEdit = $("<div id='diveditWidgetHtmlEditor" + idxInstance + "' style='padding:0 5px;height:100%;border-radius:0;border:none;overflow:auto;scrollbar-gutter: stable;' class=''/>").appendTo(contentElement)
        resizeObserver.mAdd($DivToolBar, function () { $DivEdit.css("height", "calc(100% - " + $DivToolBar.innerHeight() + "px)") })
        tinymce.init({
            selector: "#diveditWidgetHtmlEditor" + idxInstance,
            height: "100%",
            browser_spellcheck: true,
            valid_children: '+span[table]', //le + permet de spécifier un rajout de "valid_children"
            inline: false, //((typeof option.inline != 'undefined') ? option.inline : false),
            skin: 'oxide-dark',        // Name of the skin  // change this value according to your HTML
            content_style: option.content_style,
            content_css: parametre.urldispatch + "/js/plugin/tinymce/skins/content/oxide-dark/content.min.css?v=" + parametre.version,
            ////mode: "exact",
            entity_encoding: "raw", //encodage des caractères
            keep_styles: true, //garde le style sur entrée
            forced_root_block: option.forced_root_block, //utilise <div> comme élément pour les saut de lignes plutôt que <p>
            link_default_target: "_blank",
            line_height_formats: "0.5 0.6 0.7 0.8 0.9 1 1.1 1.2 1.3 1.4 1.5 2",
            font_size_formats: '8px 10px 12px 14px 16px 18px 20px 25px 30px 36px 48px',
            paste_data_images: true,
            image_advtab: true,
            image_uploadtab: false,
            promotion: false,
            toolbar_mode: 'sliding',
            menubar: false,
            toolbar: option.toolbar + " tag" + idxInstance,
            block_formats: 'Paragraphe=p; Titre 1=h1; Titre 2=h2; Titre 3=h3; Titre 4=h4',
            toolbar_sticky: false,
            toolbar_persist: true,
            fixed_toolbar_container: "#divhtmltoolbar" + idxInstance,
            statusbar: false,
            language: 'fr_FR',
            plugins: 'lists advlist autolink charmap code emoticons link image searchreplace table',
            setup: function (editor) {
                editorHtml = editor
                editor.on('init', (e) => {

                    editor.iframeElement.setAttribute('title', '');

                    editorHtml.on('focus', function (e) {
                        if (typeof option.onFocus != 'undefined') option.onFocus(Me)
                    });

                    editorHtml.on('blur', function (e) {
                        if (typeof option.onBlur != 'undefined') option.onBlur(Me)
                    });

                    Me.isInit = true

                    window.setTimeout(function () {
                        Me.element().find("button[title='Polices']").css("width", "110px")
                        Me.element().find("button[title='Taille de police']").css("width", "70px")
                        Me.element().find("button[title='Blocs']").css("width", "110px")
                    }, 0)


                    Me.element().find(".mce-content-body").addClass("bodyassistantemail templatetext")
                    if (typeof option.onContentReady != 'undefined') option.onContentReady({ component: Me })
                    window.setTimeout(function () { container.find(".tox-editor-header").css("border-radius", "0") }, 0)
                    //container.find(".tox-editor-header").css("border-radius", "0")
                    //container.find(".tox-tinymce").css({ "width": "100%" })
                });
            },
        });
    }

    this.element = function () { return container }

    mConstruit();
}